export default {
  subtitle: 'Leading Job Transferring Agency in Japan',
  about: {
    header: 'About "G Talent"',
    body: 'is a recruitment support service for global talent, specializing in the IT, mechanical, and electrical engineering sectors. We cover a wide range of positions, from hands-on engineering roles to management and specialized professions such as Project Managers and Bridge SEs. Our highly specialized, multinational team supports experienced and high-class professionals looking to advance their careers in a global environment.',
    highlight: 'G Talent'
  },
  why: {
    header: 'Why G Talent?',
    expertSupport: {
      title: 'Expert Support',
      body: 'Guidance from Japanese and bilingual advisors (fluent in Japanese, English, Chinese, Vietnamese, etc.) throughout the entire process.'
    },
    careerAdvancement: {
      title: 'Career Advancement',
      body: 'We help you accurately assess your market value to achieve skill development and salary increases.'
    }
  },
  applicationProcess: {
    header: 'Application Process',
    body: 'Our advisors will conduct a career consultation to highlight your strengths before recommending you to the employer.',
    steps: {
      applicationRegistration: 'Application & Registration',
      careerConsultation: 'Career Consultation',
      referralToEmployer: 'Referral to Employer',
      selectionJobOffer: 'Selection & Job Offer'
    },
    noteTitle: 'Note for existing members',
    noteBody: 'A consultant will contact you directly to proceed with the recommendation process.',
    disclaimerTitle: 'Disclaimer',
    disclaimerBody: 'Please be aware that we may not be able to offer a consultation depending on your background or current job market availability.'
  }
}
